import React from "react";

import { defined } from "@formant/core/common/defined";
import { IDeviceDetails } from "@formant/core/model/IDeviceDetails";

import { useRouter } from "../../../context/RouterContext";
import { NoDataMessage } from "../../common/NoDataMessage";
import { RestrictedComponent } from "../../common/RestrictedComponent";
import { AddButton } from "../AddButton";
import { LinkList } from "../LinkList";
import { LinkListItem } from "../LinkListItem";
import { ListHeader } from "../ListHeader";
import {
    TeleopAvatar,
    TeleopIcon,
    TeleopListSection,
} from "./TeleopList.styles";

export interface ITeleopListProps {
    onClose: () => void;
    loading: boolean;
    devices: IDeviceDetails[] | undefined;
    deviceOwners: Map<string, string>;
}

export const TeleopList = (props: ITeleopListProps) => {
    const { loading, devices, deviceOwners, onClose } = props;
    const { routeTo } = useRouter();

    const items = (devices ?? []).map(device => {
        const id = defined(device.id);
        return (
            <LinkListItem
                key={id}
                icon={<TeleopIcon name="teleop" />}
                title={device.name}
                to={routeTo.teleop({ id })}
                onClicked={onClose}
                data-testid={`sidebar-teleop-device-${id}`}
            >
                <TeleopAvatar size="tiny" userId={deviceOwners.get(id)} />
            </LinkListItem>
        );
    });

    const list =
        items.length === 0 ? (
            <NoDataMessage>No devices available</NoDataMessage>
        ) : (
            <LinkList>{items}</LinkList>
        );

    return (
        <TeleopListSection loading={loading}>
            <ListHeader title="Devices">
                <RestrictedComponent
                    resource="devices"
                    requiredAccess="administrator"
                >
                    <AddButton
                        to={routeTo.createDevice()}
                        onClicked={onClose}
                        data-tooltip="Provision a new device"
                        data-testid="provision-teleop-device-button"
                    />
                </RestrictedComponent>
            </ListHeader>
            {list}
        </TeleopListSection>
    );
};
